import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Gleap from "gleap";
import { isGleapInitialized, markGleapInitialized } from "../lib/kaiChat";

// Routes where the Gleap chat bubble (and any related UI) is allowed
const ENABLED_ROUTES = ["/for-licensors", "/for-licensees"];

/**
 * Lazy-initializes Gleap on first navigation to an enabled route, then toggles
 * visibility of all Gleap UI (bubble, AI widget, outbound notifications) using
 * a body-level CSS class on every route change.
 *
 * Footer's "Chat with Kai" button can also init/open Gleap — see lib/kaiChat.
 */
export default function GleapBubble() {
  const { pathname } = useLocation();

  useEffect(() => {
    const enabled = ENABLED_ROUTES.includes(pathname);

    if (enabled && !isGleapInitialized()) {
      const key = process.env.REACT_APP_GLEAP_KEY;
      if (key) {
        Gleap.initialize(key);
        markGleapInitialized();
      }
    }

    document.body.classList.toggle("gleap-disabled-route", !enabled);

    if (isGleapInitialized() && !enabled) {
      Gleap.close();
    }
  }, [pathname]);

  return null;
}
